export default defineNuxtRouteMiddleware(async (to, from) => {
  // Access the UI store
  const ui = useUiStore()
  // Breadcumbs maintenance
  ui.clearBreadcrumbs(to)
  // Close navigation
  ui.clearNavigation()
  // Clear page favorite
  ui.clearPageFavorite()
  // Clear page actions
  const newRouteName = to.name !== from.name
  if (newRouteName) ui.clearPageActions()
})
